export type ThemeChoice = "light" | "dark" | "auto";

const KEY = "triage-theme";

// Auto follows the system setting, so it is stored as nothing.
export function loadTheme(): ThemeChoice {
  try {
    const stored = localStorage.getItem(KEY);
    return stored === "light" || stored === "dark" ? stored : "auto";
  } catch {
    return "auto";
  }
}

export function applyTheme(choice: ThemeChoice): void {
  const root = document.documentElement;
  if (choice === "auto") {
    delete root.dataset.theme;
  } else {
    root.dataset.theme = choice;
  }
}

export function saveTheme(choice: ThemeChoice): void {
  try {
    if (choice === "auto") {
      localStorage.removeItem(KEY);
    } else {
      localStorage.setItem(KEY, choice);
    }
  } catch {
    // Storage can be blocked; the choice still applies until the page is closed.
  }
  applyTheme(choice);
}
